export default {
    namespaced: true,
    state: {
        idRilevamento: null,
        idTag: null,
        giudizioRadiciColletto: -1,
        giudizioFustoBranche: -1,
        giudizioRamiChioma: -1,
        contesto: -1,
        interventiFitosanitari: [],
        potatura: false,
        monitoraggio: -1
    },
    mutations: {
        SET_ID_RILEVAMENTO: (state: any, payload: number) => {
            state.idRilevamento = payload
        },
        SET_ID_TAG: (state: any, payload: number) => {
            state.idTag = payload
        },
        SET_GIUDIZIO_RADICI_COLLETTO: (state: any, payload: number) => {
            state.giudizioRadiciColletto = payload
        },
        SET_GIUDIZIO_FUSTO_BRANCHE: (state: any, payload: number) => {
            state.giudizioFustoBranche = payload
        },
        SET_GIUDIZIO_RAMI_CHIOMA: (state: any, payload: number) => {
            state.giudizioRamiChioma = payload
        },
        SET_CONTESTO: (state: any, payload: number) => {
            state.contesto = payload
        },
        SET_POTATURA: (state: any, payload: boolean) => {
            state.potatura = payload
        },
        SET_INTERVENTI_FITOSANITARI: (state: any, payload: number[]) => {
            state.interventiFitosanitari = payload
        },
        SET_MONITORAGGIO: (state: any, payload: number) => {
            state.monitoraggio = payload
        }
    },
    actions: {
        setInterventiFitosanitari({commit}: any, payload: number[]) {
            commit('SET_INTERVENTI_FITOSANITARI', payload)
        },
        setPotatura({commit}: any, payload: boolean) {
            commit('SET_POTATURA', payload)
        },
        setMonitoraggio({commit}: any, payload: number) {
            commit('SET_MONITORAGGIO', payload)
        }
    }
}
